export default __webpack_public_path__ + "static/media/georg-hansbauer.ab37b961.jpg";